import { FilterV2, SearchV2, SortV2 } from '@cimplico/components';
import { useState } from 'react';
import { useUsers } from '../../../../queries/use-users';
import GrowHeightContainer from '../../../../components/GrowHeightContainer';
import { WorkpaperStatusEnum } from '../../../../types/workpaper';
import { useEntities } from '../../../../queries/use-entities';

const sortOptions = [
    { label: 'Due', value: 'dueDate' },
    { label: 'Period End', value: 'periodEnd' },
    { label: 'Name', value: 'name' },
    { label: 'Entity', value: 'entityName' },
    { label: 'Last Updated', value: 'updatedAt' },
    { label: 'Progress', value: 'progressPercent' },
];

type WorkpapersPrimaryActionsProps = {
    onFilterChange: (qs: string) => void;
    onSearchChange: (qs: string) => void;
    onSortChange: (qs: string) => void;
};

function WorkpapersPrimaryActions({ onFilterChange, onSearchChange, onSortChange }: WorkpapersPrimaryActionsProps): JSX.Element {
    const usersQuery = useUsers({ page: 1, search: '', sort: '', filter: '' });
    const [statusIndex, setStatusIndex] = useState(0);

    const entitiesQuery = useEntities({ page: 1, search: '', sort: '', filter: '' });

    return (
        <div className="flex gap-4 items-center w-full">
            <GrowHeightContainer className="flex flex-wrap items-center gap-2">
                <FilterV2
                    onChange={({ queryString }): void => {
                        onFilterChange(queryString);
                    }}
                >
                    {statusIndex === 0 && (
                        <FilterV2.CheckboxFilter
                            options={[
                                { label: 'Open', value: WorkpaperStatusEnum.ACTIVE },
                                { label: 'Complete', value: WorkpaperStatusEnum.COMPLETE },
                                { label: 'Archived', value: WorkpaperStatusEnum.ARCHIVED },
                            ]}
                            id="status"
                            label="Status"
                        />
                    )}
                    <FilterV2.ToggleFilter prefix="is" id="overdue" label="Overdue" />
                    <FilterV2.SelectFilter
                        id="entity.name"
                        label="Entity"
                        values={[]}
                        options={entitiesQuery.data?.entities?.map((e) => ({ value: e.id, label: `${e.name}` })) ?? []}
                    />
                    {statusIndex !== 3 && (
                        <FilterV2.SelectFilter
                            id="assigned"
                            label="Assigned"
                            values={[]}
                            options={usersQuery.data?.users?.map((u) => ({ value: u.id, label: `${u.firstName} ${u.lastName}` })) ?? []}
                        />
                    )}
                    <FilterV2.CheckboxFilter
                        id="certified"
                        label="Certified"
                        options={[
                            { label: 'Preparer', value: 'PREPARER' },
                            { label: 'Reviewer', value: 'REVIEWER' },
                            { label: 'Approver', value: 'APPROVER' },
                        ]}
                    />
                    <FilterV2.DateFilter id="updatedAt" label="Last Updated" />
                    <FilterV2.DateFilter id="dueDate" label="Due Date" />
                    <FilterV2.NumericFilter id="progress" label="Progress%" />
                </FilterV2>
                <SearchV2 placeholder="Search workpapers..." onChange={onSearchChange} />
                <SortV2
                    options={statusIndex === 0 ? [...sortOptions] : sortOptions}
                    defaultValue="Due"
                    defaultDirection="asc"
                    onChange={({ queryString }): void => {
                        onSortChange(queryString);
                    }}
                />
            </GrowHeightContainer>
        </div>
    );
}
export default WorkpapersPrimaryActions;
